// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"22":"datenschutz","42":"impressum"}[chunkId] || chunkId) + "." + {"22":"a74c0f0f","42":"f2e4b21e","829":"5281d99d"}[chunkId] + ".js";
};